/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1ClassesStudentsRetrieveState = typeof V1ClassesStudentsRetrieveState[keyof typeof V1ClassesStudentsRetrieveState];


export const V1ClassesStudentsRetrieveState = {
  all: 'all',
  deleted: 'deleted',
  disabled: 'disabled',
} as const;
